import DOMPurify from 'dompurify';

/**
 * Détecte si le contenu ressemble à un document HTML complet
 * (généré par une IA, copié depuis un éditeur, etc.)
 */
export const isFullHtmlDocument = (content: string): boolean => {
  const trimmed = content.trim();
  if (!trimmed || trimmed.length < 10) {
    return false;
  }
  return (
    trimmed.includes('<!DOCTYPE') ||
    trimmed.includes('<html') ||
    (trimmed.includes('<style') && trimmed.includes('</style>')) ||
    (trimmed.startsWith('<') && trimmed.includes('</'))
  );
};

/**
 * Configuration permissive pour le HTML admin (bannière promo).
 * Permet style, html, head, body, meta, etc. pour les documents complets.
 * DOMPurify continue de bloquer les scripts et vecteurs XSS.
 */
const RICH_HTML_CONFIG = {
  WHOLE_DOCUMENT: true,
  USE_PROFILES: { html: true },
  ADD_TAGS: ['html', 'head', 'body', 'style', 'meta', 'title', 'link'],
  ADD_ATTR: ['charset', 'content', 'http-equiv', 'name', 'media', 'rel', 'href'],
};

/**
 * Sanitise le HTML riche (documents complets) tout en préservant
 * les balises de structure et les styles.
 */
export const sanitizeRichHtml = (html: string): string => {
  return DOMPurify.sanitize(html, RICH_HTML_CONFIG);
};
